import { render } from "./Formato2012.vue?vue&type=template&id=6d009f6c&scoped=true"
import script from "./Formato2012.vue?vue&type=script&lang=js"
export * from "./Formato2012.vue?vue&type=script&lang=js"

import "./Formato2012.vue?vue&type=style&index=0&id=6d009f6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d009f6c"]])

export default __exports__